// RateLimitStore.js
// Tiny framework-agnostic store (no Redux slice needed) for the rate-limit
// freeze overlay. Exposes a React hook via useSyncExternalStore so it works
// both inside components (RateLimitOverlay) and outside them (AxiosConfig.js).
import { useSyncExternalStore } from "react";

const FREEZE_DURATION_MS = 30000;

let state = {
  isFrozen: false,
  freezeUntil: null, // epoch ms timestamp the freeze ends at
};

const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener());
}

export function getRateLimitState() {
  return state;
}

export function subscribeRateLimit(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Called whenever a 429 is hit. Extends/(re)starts the 30s freeze window even
// if a freeze is already in progress (bursty 429s keep resetting the timer).
export function triggerFreeze() {
  state = { isFrozen: true, freezeUntil: Date.now() + FREEZE_DURATION_MS };
  emit();
}

export function clearFreeze() {
  state = { isFrozen: false, freezeUntil: null };
  emit();
}

export function useRateLimitState() {
  return useSyncExternalStore(subscribeRateLimit, getRateLimitState);
}
